import { InputText } from "primereact/inputtext";
import { useMemo, useRef } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import useForm from "../../utils/hooks/useForm";
import { Form, FormFieldContainer } from "./styles";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import sendFormData from "../../utils/sendFormData";

const FORM_NAME = "adoptAnimalForm";

const AdoptAnimalForm = () => {
  const toastRef = useRef();
  const { t } = useTranslation();
  const fields = useMemo(
    () => [
      {
        name: "email",
        label: t("email"),
        type: "email",
        component: InputText,
      },
      {
        name: "name",
        label: t("yourName"),
        component: InputText,
      },
      {
        name: "telephone",
        label: t("telephone"),
        component: InputText,
        type: "tel",
      },
      {
        name: "message",
        label: t("message"),
        component: InputTextarea,
        className: "p-inputtext-lg",
      },
    ],
    [t]
  );
  const {
    formValues,
    handleFormChange,
    resetFormValues,
    handleSubmit,
    isSubmitting,
    hasError,
  } = useForm(fields, async (formValues) => {
    try {
      await sendFormData({
        ...formValues,
        "form-name": FORM_NAME,
      });
      toastRef.current.show({
        severity: "success",
        summary: t("adoptionSuccess"),
        detail: t("adoptionSuccessfulSubmission"),
        life: 6000,
      });
      resetFormValues();
    } catch (err) {
      toastRef.current.show({
        severity: "error",
        summary: t("adoptionFailure"),
        detail: t("adoptionFailedSubmission"),
        life: 6000,
      });
    }
  });

  return (
    <Form onSubmit={handleSubmit} name={FORM_NAME} data-netlify="true">
      <Toast ref={toastRef} position="bottom-right" />
      <input type="hidden" value={FORM_NAME} name="form-name" />
      {fields.map((field) => (
        <FormFieldContainer key={field.name}>
          <span className="p-float-label">
            <field.component
              name={field.name}
              value={formValues[field.name]}
              onChange={handleFormChange}
              type={field.type}
              className={field.className}
            />
            <label htmlFor={field.name}>{field.label}</label>
          </span>
        </FormFieldContainer>
      ))}
      <div>
        <Button type="submit" disabled={isSubmitting || hasError}>
          {t("submit")}
        </Button>
      </div>
    </Form>
  );
};

export default AdoptAnimalForm;
